import * as Yup from 'yup';
import { reverseShape } from 'Helpers/index';
import { addressLine,postcode } from 'Utils/validations';

const PrimaryAddressFormSchema = Yup.object().shape(
  reverseShape({
    addressLine1: Yup.string().required().concat(addressLine),
    addressLine2: addressLine,
    city: Yup.string().when('country', {
      is: 'MY',
      then: Yup.string().required(),
    }),
    postcode: postcode.required(),
    state: Yup.string().required(),
    country: Yup.string().required(),

    // * other fields for business account
    accountType: Yup.string().optional(), // for reference for conditional validation
    businessName: Yup.string().when('accountType', {
      is: 'BUSINESS_ACCOUNT',
      then: Yup.string().required(),
      otherwise: Yup.string().optional(),
    }),
    registrationNo: Yup.string().optional(),
  })
)

export default PrimaryAddressFormSchema;
